import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
}
export const getAllEmojis = createAsyncThunk(
    "getAllEmojis",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/hummingbird/emoji/get-emoji-list?page=${body.page}&search=${body.search}`);
            return response.data;

        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)



export const EmojisSlice = createSlice({
    name: 'EmojisSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllEmojis.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllEmojis.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload
            state.count = action?.payload?.count;
        })
        builder.addCase(getAllEmojis.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });



    },

})

export default EmojisSlice.reducer;